import type { ActionPriority } from "../types";

const STYLES: Record<
  ActionPriority,
  { bg: string; fg: string; label: string }
> = {
  CRITICAL: { bg: "hsl(0,70%,94%)", fg: "hsl(0,70%,40%)", label: "Critical" },
  HIGH: { bg: "hsl(20,85%,92%)", fg: "hsl(20,85%,38%)", label: "High" },
  MEDIUM: { bg: "hsl(38,90%,92%)", fg: "hsl(32,90%,38%)", label: "Medium" },
  LOW: { bg: "hsl(210,16%,93%)", fg: "hsl(215,16%,40%)", label: "Low" },
};

export function ActionPriorityBadge({
  priority,
}: {
  priority: ActionPriority;
}) {
  const s = STYLES[priority];
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{ background: s.bg, color: s.fg }}
    >
      {s.label}
    </span>
  );
}
